'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function compose() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (argument) {
    return args.reduceRight(function (result, fn) {
      return fn(result);
    }, argument);
  };
}

exports.default = compose;
//# sourceMappingURL=compose.js.map
